import { useCallback, useEffect, useRef, useState } from 'react';
import { delay } from 'utils';

type SectionToggleObject<T> = [
  T | undefined,
  (id: T) => () => void,
  () => void,
  (id: T | undefined) => void
];
export function useMenuToggle<T>(parent: boolean, isLoading: boolean): SectionToggleObject<T> {
  const delayRef = useRef(delay());
  useEffect(() => delayRef.current.cleanup, []);
  const [openId, setValue] = useState<T | undefined>();
  const setOpen = useCallback(
    (id: T | undefined) => delayRef.current.setDelay(() => id !== openId && setValue(id)),
    [openId]
  );
  const open = (id: T) => () => setOpen(id);
  const close = setOpen as () => void;
  useEffect(() => {
    if (!parent || !isLoading || openId === undefined) {
      return;
    }
    delayRef.current.cleanup();
    setOpen(undefined);
  }, [parent, isLoading, openId, setOpen]);
  return [openId, open, close, setOpen];
}
